import React from 'react';
import { AppRouter } from './routers/AppRouter';
import './styles/global-style.css';
import { AuthProvider } from './Auth/Context/AuthProvider';
import ChatWex from './components/organisms/ChatWex';
import { MOCK_OM_CHAT_DRIVER } from './utils/Mocks/MOCK_OM';

function App() {
  return (
    <AuthProvider>
      <AppRouter />
      {/*<ChatWex
        titleChat="Chat repartidor - soporte"
        messageChat={MOCK_OM_CHAT_DRIVER}
        isDriver={true}
      />*/}
    </AuthProvider>
  );
}

export default App;
